import React from 'react';

import "./css/Footer.css";
const footer = () => (
    <div className="footer">Copyright &#169; 2020 APPNAME.</div>
);
export default footer;
